// extracted by mini-css-extract-plugin
export var bodyRow = "_cw-d";
export var cardColumns = "_cw-e";
export var ellipsesOverflow = "_cw-2";
export var flatBottomCorners = "_cw-3";
export var flatTopCorners = "_cw-4";
export var headerActionsDropdown = "_cw-f";
export var headerBottomRow = "_cw-c";
export var headerTopRow = "_cw-b";
export var orderDetailsWrapper = "_cw-0";
export var orderInfoContainer = "_cw-1";
export var productDetails = "_cw-9";
export var productImage = "_cw-5";
export var responsiveTable = "_cw-8";
export var shipmentContainer = "_cw-a";
export var tableBottomLeft = "_cw-6";
export var tableBottomRight = "_cw-7";
export var trackingLink = "_cw-g";